import { Component, inject, Input, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { createModelSelector, Store } from '@ngxs/store';
import { FetchOptionsState } from '../../state/fetchOptions.state';
import { FetchOptionsActions } from '../../state/fetchOptions.actions';

@Component({
  selector: 'pixl-main-pagination',
  imports: [
    MatPaginator
  ],
  templateUrl: './main-pagination.component.html',
  styleUrl: './main-pagination.component.scss'
})
export class MainPaginationComponent implements OnDestroy {
  private readonly store = inject(Store);
  @Input() pageChangeCallback?: (event: PageEvent) => void;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  paginationData = this.store.selectSignal(createModelSelector({
    pageSize: FetchOptionsState.getPageSize,
    pageNumber: FetchOptionsState.getPageNumber,
    total: FetchOptionsState.getTotal
  }));

  handlePageEvent(e: PageEvent) {
    this.store.dispatch(new FetchOptionsActions.UpdatePageSize(e.pageSize));
    this.store.dispatch(new FetchOptionsActions.UpdatePageNumber(e.pageIndex + 1));
    if (this.pageChangeCallback) {
      this.pageChangeCallback(e);
    }
  }

  ngOnDestroy(): void {
    this.store.dispatch(new FetchOptionsActions.ToDefault());
  }
}
